import { SVGProps } from 'react';

export const RateIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='15'
    height='13'
    viewBox='0 0 15 13'
    fill='none'
    {...props}>
    <rect x='1' y='8' width='1.5' height='5' rx='0.75' />
    <rect x='5' y='5' width='1.5' height='8' rx='0.75' />
    <rect x='9' y='2' width='1.5' height='11' rx='0.75' />
    <rect x='13' width='1.5' height='13' rx='0.75' />
  </svg>
);
